// extracted by mini-css-extract-plugin
export default {"root":"_3tf5Z","arrow":"B4Gf-"};